import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// Last-resort fallback: the root route's errorElement, hit only by a loader
// throwing or a render error outside DashboardPage's own Sentry.ErrorBoundary
// (e.g. on /auth/*). Kept on-brand and translated instead of the bare
// react-router starter placeholder this used to be.
export default function ErrorPage() {
  const { t } = useTranslation('errors')
  const error = useRouteError()

  console.error(error)

  const statusText = isRouteErrorResponse(error) ? error.statusText : undefined

  return (
    <div className="h-screen w-full flex items-center justify-center bg-neutralBlack-100 px-6">
      <div className="max-w-sm w-full bg-white border border-neutralBlack-200 rounded-2xl shadow-sm px-7 py-8 flex flex-col items-center gap-3 text-center">
        <span className="text-[17px] font-semibold text-neutralBlack-900">{t('errors.pageErrorTitle')}</span>
        <p className="text-[13.5px] text-neutralBlack-500 leading-relaxed">
          {statusText || t('errors.pageErrorMessage')}
        </p>
        <div className="flex items-center gap-2.5 mt-2">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="h-9 px-4 rounded-full bg-neutralBlack-900 text-white text-[13px] font-medium hover:bg-neutralBlack-700"
          >
            {t('errors.pageErrorReload')}
          </button>
          <a
            href="/dashboard"
            className="h-9 flex items-center px-4 rounded-full border border-neutralBlack-200 bg-white text-[13px] text-neutralBlack-700 hover:bg-neutralBlack-50 no-underline"
          >
            {t('errors.pageErrorHome')}
          </a>
        </div>
      </div>
    </div>
  )
}
